let devRoutes=[
    {path:"/",component:()=>import("../../views/layout/auth/AuthLayout"),
        children:[
            {path:"login",name:"Login",component:()=>import("../../views/dev/Login")},
            {path:"llogin",name:"admLogin",component:()=>import("../../views/dev/admLogin")},
        ]}];export
const setDevRoutes=e=>{"dev"===window.localStorage.getItem("search")&&devRoutes[0].children.push({path:"search",name:"Search",component:()=>import("@/views/dev/Search")}),e.push(...devRoutes)};
